const state = {
  notesFromDB: {},
  itensFromSPED: [],
  itensFromXML: [],
};

export default state;
